import { render } from "./WCMobileHeaderV2.vue?vue&type=template&id=4be58adb&scoped=true"
import script from "./WCMobileHeaderV2.vue?vue&type=script&lang=js"
export * from "./WCMobileHeaderV2.vue?vue&type=script&lang=js"

import "./WCMobileHeaderV2.vue?vue&type=style&index=0&id=4be58adb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be58adb"]])

export default __exports__